import { __read, __awaiter, __generator, __spreadArray, __assign } from 'tslib';
import { useState, useEffect } from 'react';
import { useContentfulClient } from '../engine/client.esm.js';

var useResolvedEntries = function (initialEntries) {
    var _a = __read(useState([]), 2), resolvedEntries = _a[0], setResolvedEntries = _a[1];
    var client = useContentfulClient();
    useEffect(function () {
        initialEntries.forEach(function (entry) { return __awaiter(void 0, void 0, void 0, function () {
            var resolvedEntry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resolvedEntry = entry;
                        if (!!entry.fields) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.getEntry(entry.sys.id)];
                    case 1:
                        resolvedEntry = _a.sent();
                        _a.label = 2;
                    case 2:
                        setResolvedEntries(function (previousEntries) { return __spreadArray(__spreadArray([], __read(previousEntries), false), [resolvedEntry], false); });
                        return [2 /*return*/];
                }
            });
        }); });
    }, [initialEntries]);
    return resolvedEntries;
};
/**
 * Transforms Contentful Asset object into our own IMedia model.
 *
 * @param {Asset}
 */
function deserializeMedia(_a) {
    var fields = _a.fields;
    var title = fields.title, description = fields.description, file = fields.file;
    var url = file.url, contentType = file.contentType, details = file.details;
    return {
        description: description,
        details: details,
        fileContentType: contentType,
        fileUrl: url,
        title: title,
    };
}
var extractDataFromTextCopies = function (textCopies) {
    if (!(textCopies === null || textCopies === void 0 ? void 0 : textCopies.length))
        return;
    return textCopies.reduce(function (accumulator, copy) {
        var _a, _b;
        var _c, _d, _e, _f, _g;
        var id = copy.sys.contentType.sys.id;
        if (id === 'media') {
            var mediaCopy = copy;
            var key = (_c = mediaCopy.fields) === null || _c === void 0 ? void 0 : _c.key;
            if (key && ((_d = mediaCopy.fields) === null || _d === void 0 ? void 0 : _d.media)) {
                return __assign(__assign({}, accumulator), (_a = {}, _a[key] = deserializeMedia((_e = mediaCopy.fields) === null || _e === void 0 ? void 0 : _e.media), _a));
            }
            throw Error("No key for media copy");
        }
        if (id === 'textCopy') {
            var textCopy = copy;
            var key = (_f = textCopy.fields) === null || _f === void 0 ? void 0 : _f.key;
            if (key) {
                return __assign(__assign({}, accumulator), (_b = {}, _b[key] = ((_g = textCopy.fields) === null || _g === void 0 ? void 0 : _g.copy) || null, _b));
            }
            throw Error("No key for text copy");
        }
        return __assign({}, accumulator);
    }, {});
};

export { deserializeMedia, extractDataFromTextCopies, useResolvedEntries };
//# sourceMappingURL=contentful.esm.js.map
